"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Util =
/** @class */
function () {
  function Util() {}
  /**
   * Parse a URL with the help of an A-tag
   *
   * @param {string} href
   * @return {EndpointURLInterface}
   */


  Util.parseUrl = function (href) {
    var aTag = document.createElement('a');
    aTag.href = href;
    return aTag;
  };
  /**
   * Return a string representation describing the given input
   *
   * @param {S} input
   * @return {string}
   */


  Util.inspectType = function (input) {
    var type = typeof input;

    if (input === null) {
      return '(object) null';
    }

    if (type === 'object') {
      return '(object) ' + input.constructor.name;
    }

    return '(' + type + ')';
  };

  return Util;
}();

exports.Util = Util;